// extracted by mini-css-extract-plugin
module.exports = {"navLink":"nav-link_navLink__2q9eB","active":"nav-link_active__37Jad"};